import React from 'react';
import { Container } from '../ui/Container';
import { SectionHeading } from '../ui/SectionHeading';
export const HowItWorksSection: React.FC = () => {
  const steps = [{
    title: 'Digital Targeting',
    description: 'We place hyper targeted Meta and Google ads in front of sellers based on industry, geography, EBITDA, and motivation.'
  }, {
    title: 'Conversion Optimized Sales Funnels',
    description: 'Custom funnels & automated deal filtering to screen for size, timing, and reason for selling—before you ever speak to a lead.'
  }, {
    title: 'SDR Screening (Human Verified Leads)',
    description: 'Every seller lead has a real call with our internal SDR team where we verify financials, confirm exit readiness, and prep a summary before handing them off to your deal team.'
  }, {
    title: 'Deal Delivery',
    description: 'You receive pre-vetted, fully qualified seller leads daily so your deal team spends zero time on sellers outside your buy box.'
  }];
  return <section className="w-full bg-gradient-to-b from-dark-900 to-dark-800 py-24 relative" data-id="element-620">
      <div className="absolute inset-0 bg-[url('https://transparenttextures.com/patterns/carbon-fibre.png')] opacity-5" data-id="element-621" />
      <Container className="relative" data-id="element-622">
        <SectionHeading title="A Fully Managed, Done-For-You Deal Sourcing Engine" centered className="text-white" data-id="element-623" />
        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-624">
          {steps.map((step, index) => <div key={index} className="bg-dark-700 rounded-lg p-8 shadow-lg shadow-black/20 border border-dark-500" data-id="element-625">
              <div className="flex items-center mb-4" data-id="element-626">
                <div className="w-12 h-12 aspect-square rounded-full bg-[#00c853] text-white flex items-center justify-center font-bold mr-4" data-id="element-627">
                  {index + 1}
                </div>
                <h3 className="text-xl font-semibold text-white" data-id="element-628">
                  {step.title}
                </h3>
              </div>
              <p className="text-gray-300" data-id="element-629">{step.description}</p>
            </div>)}
        </div>
        <p className="mt-12 text-xl text-center font-medium text-gray-200" data-id="element-630">
          No cold calls. Just inbound, pre-qualified seller leads.
        </p>
      </Container>
    </section>;
};